import { DataTable } from "./data-table";
import { columns } from "./columns";
import { useGetAllModels } from "../../../api/routes/models";

export const ModelsRoute = () => {
    const { data: models, isLoading } = useGetAllModels();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <div
            className="mx-auto py-10 px-32
        "
        >
            <DataTable columns={columns} data={models} />
        </div>
    );
};
